import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { SchemaData, UseUpdateProps } from "./types";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { UPDATE_QUERY, UpdateGql } from "../queries/update";
import { ApiCourseRequest } from "data/queries/ApiCourse";
import { verifySlug } from "./verifySlugCourse";

export default function useUpdate({ queryParam }: UseUpdateProps) {
  const navigate = useNavigate();
  const handleSave = useCallback(
    async (state: JsonFormsStateProps<SchemaData>) => {
      const { institution, startDate, ...data } = state?.data;

      await verifySlug(data.slug, Number(queryParam))
      const response = await ApiCourseRequest<UpdateGql>({
        query: UPDATE_QUERY,
        variables: {
          data: {
            ...data,
            institution: !institution ? null : institution.toUpperCase(),
            imageUrl: data?.imageUrl || null,
            description: data?.description || null,
            startDate: startDate ? new Date(startDate) : null,
            id: queryParam,
          },
        },
      });

      if (response?.data?.errors) {
        console.log(response?.data?.errors);
        throw response.data.errors[0];
      }
      if (!response?.data?.data) {
        throw new Error("Ops. Sem resposta!");
      }
      navigate(`/ecommerce/cursos/${response.data.data.updateCourse.id}/info`);
      return response;
    },
    [queryParam]
  );

  return {
    handleSave,
  };
}
